webpackJsonp([69062039818352],{

/***/ 196:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/btcbch.c138cd3a.png";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(123);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(69);
	
	var _btcbch = __webpack_require__(1047);
	
	var _btcbch2 = _interopRequireDefault(_btcbch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _semanticUiReact.Container,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h1', style: { fontWeight: 400 } },
	      'How to contribute to Arbore'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h2' },
	      'Give time'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you have time, we welcome your help in various areas:'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.List,
	      { bulleted: true },
	      _react2.default.createElement(
	        _semanticUiReact.List.Item,
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Programmers'
	        ),
	        ', to help us developing Arbore',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _semanticUiReact.List,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.List.Item,
	            { as: 'a', href: 'https://github.com/MichaelMure/Arbore' },
	            'Source code and roadmap'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.List.Item,
	            { as: 'a', href: 'https://gitter.im/Arbore/Lobby' },
	            'Gitter chat lobby'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.List.Item,
	            { as: 'a', href: 'https://github.com/MichaelMure/Arbore/issues' },
	            'Report a bug'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.List.Item,
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Designers'
	        ),
	        ', to help us for Arbore and this website, on the UI and the UX'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.List.Item,
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Translators'
	        ),
	        ', to help translate Arbore and this website when ready'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can also join the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://gitter.im/Arbore/Lobby' },
	        'Arbore\'s Gitter chatroom'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For other kind of inquiry, you can find my email on my Github profile.'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h2' },
	      'Donate'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can also support the development of Arbore by donating using bitcoin or bitcoin cash:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'Bitcoin: '
	      ),
	      _react2.default.createElement('br', null),
	      '1QDEL5bp9p6p13vgVpAMfHJR1HPu9nhmXK',
	      _react2.default.createElement(_semanticUiReact.Image, { src: _btcbch2.default, size: 'small' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'Bitcoin Cash:'
	      ),
	      _react2.default.createElement('br', null),
	      '1QDEL5bp9p6p13vgVpAMfHJR1HPu9nhmXK',
	      _react2.default.createElement(_semanticUiReact.Image, { src: _btcbch2.default, size: 'small' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contribute-js-003155b93a769c184f7c.js